"use client"
import { SectionHeadingTitle } from "@/components/SectionTitle";
import { useTranslation } from "@/hooks/translationContext"

interface Props {
    pageType: "campaign" | "event" | "company";
}

const titleKeys = {
    campaign: "campaign-commentSection-title",
    event: "event-commentSection-title",
    company: "company-discount-commentSection-title",
};

const defaultTitles = {
    campaign: "Kampanyalar Hakkında Yorum Yap/Soru Sor",
    event: "Etkinlikler Hakkında Yorum Yap/Soru Sor",
    company: "Şirket İndirimleri Hakkında Yorum Yap/Soru Sor",
};

export default function PageCommentHeader({ pageType }: Props) {
    const { t } = useTranslation();
    return (
        <SectionHeadingTitle
            title={t(titleKeys[pageType], {
                defaultValue: defaultTitles[pageType],
            })}
            icon={null}
            showRedBar
        />
    )
}
